import { sortByDate } from "@izicvs/utils";
import { useMemo, useState } from "react";

import { useResumes } from "@/client/services/resume";

export type ResumeSort = "recent" | "alpha";

// Owns the search + sort state and derives the filtered/sorted list once, so the
// grid and list layouts render from the same source.
export const useResumesView = () => {
  const { resumes, loading } = useResumes();
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState<ResumeSort>("recent");

  const filtered = useMemo(() => {
    const list = resumes ?? [];
    const query = search.trim().toLowerCase();
    const matched = query
      ? list.filter((resume) => resume.title.toLowerCase().includes(query))
      : list;

    return [...matched].sort((a, b) =>
      sort === "alpha" ? a.title.localeCompare(b.title) : sortByDate(a, b, "updatedAt"),
    );
  }, [resumes, search, sort]);

  return {
    resumes: filtered,
    total: resumes?.length ?? 0,
    loading,
    search,
    setSearch,
    sort,
    setSort,
  };
};
